import React from 'react'
import '../../styles/FastFiatTransferStyles/fastfiattransfer.css'

import '../../styles/FastFiatTransferStyles/fftblinks.css'

import platone from './../../resources/FastFiatTransferResources/platform-1.svg'
import plattwo from './../../resources/FastFiatTransferResources/platform-2.svg'

import fiat from './../../resources/FastFiatTransferResources/fiat.svg'
import kronncoin from './../../resources/FastFiatTransferResources/kronn-coin.svg'

import bgimg from './../../resources/FastFiatTransferResources/bg-img.svg'


export default class FastFiatTransfer extends React.Component{
    render(){
        return(
            <section className="fft__c-out" id='fiat-transfer-anchor'>
                <div className="fft__container">

                    <h1 className="title" style={{textAlign: 'left', marginBottom: '0px', maxWidth: '720px'}}>
                        Masked peer-to-peer transfers in domestic speeds
                    </h1>

                    <div className="fft__animation-container">
                        <div className="fft__plat-one">
                            <img className="fft__p1-img" src={platone} />
                            <img className="fft__p1__fiat" src={fiat} />
                            <img className="fft__p1-kronn" src={kronncoin} />
                            <div className="fft__p1-portal" />
                        </div>

                        {/* <div className="fft__plat-link">
                            <div className="fft__plat-link-1"/>
                            <div className="fft__plat-link-2"/>
                            <div className="fft__plat-link-3"/>
                            <div className="fft__plat-link-4"/>
                        </div> */}

                        <div className="fft__plat-two">
                            <img className="fft__p2-img" src={plattwo} />
                            <img className="fft__p2__fiat" src={fiat} />
                            <img className="fft__p2-kronn" src={kronncoin} />
                            <div className="fft__p2-portal" />
                        </div>
                    </div>

                    <div className="fft__bg-img-container">
                        <img src={bgimg} />
                        <div className="fft__bg-b-1"/>

                        <div className="fft__bg-b-2"/>
                        <div className="fft__bg-b-3"/>

                        <div className="fft__bg-b-4"/>
                        <div className="fft__bg-b-5"/>

                        <div className="fft__bg-b-6"/>
                        <div className="fft__bg-b-7"/>
                        <div className="fft__bg-b-8"/>

                        <div className="fft__bg-b-9"/>
                        <div className="fft__bg-b-10"/>
                        <div className="fft__bg-b-11"/>
                        <div className="fft__bg-b-12"/>

                        <div className="fft__bg-b-13"/>
                        <div className="fft__bg-b-14"/>
                        
                        <div className="fft__bg-b-15"/>
                        <div className="fft__bg-b-16"/>

                        <div className="fft__bg-b-17"/>
                        <div className="fft__bg-b-18"/>
                        <div className="fft__bg-b-19"/>

                        <div className="fft__bg-b-20"/>
                        <div className="fft__bg-b-21"/>
                        <div className="fft__bg-b-22"/>
                        <div className="fft__bg-b-23"/>

                        <div className="fft__bg-b-24"/>
                    </div>

                    <div className="fft__text text">
                        Transferring wealth from an individual to another,
                        has for long been a heavily tolled practice by regulators
                        and providers alike. By marrying our global network of
                        exchange bureaus to the KRONN Coin, we present to you a use case that circumvents both queues and fines while keeping our ledger closed to public inspection.
                    </div>

                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/FastFiatTransfer/FastFiatTransfer.js